import { isEmpty } from "@common/lib/util"
import TableBodyRow from "@common/table/body/tableBodyRow"
import {
  RTable,
  ReactTableProps,
  RowExpandState,
  TableRow,
} from "@common/table/types"
import { Virtualizer, type VirtualItem } from "@tanstack/react-virtual"

type TableBodyProps = {
  table: RTable
  virtualRows?: VirtualItem[]
  totalHeight?: number
  rowVirtualizer?: Virtualizer<Element, Element>
} & RowExpandState &
  Pick<ReactTableProps, "onRowClick" | "wrapRowInLink" | "getLinkHref">

export function TableBody({
  table,
  onRowClick,
  virtualRows,
  totalHeight,
  rowVirtualizer,
  ...rest
}: TableBodyProps) {
  const tableRows = table.getRowModel().rows
  const searchText = table.refs.searchInputRef.current
  const isVirtual = !!(table.options.enableRowVirtualization && virtualRows?.length)
  const rows = isVirtual ? virtualRows : tableRows
  const virtualStyles = isVirtual
    ? {
        height: `${totalHeight}px`,
        width: "100%",
        position: "relative",
      }
    : undefined
  return (
    <tbody className="table-body" style={virtualStyles as any}>
      {searchText && isEmpty(tableRows) && (
        <tr className="table-row group">
          <td className="px-4 py-2" colSpan={2}>
            No results found!
          </td>
        </tr>
      )}
      {rows.map((virtualOrRow) => {
        const row = isVirtual
          ? tableRows[virtualOrRow.index]
          : (virtualOrRow as TableRow)
        const virtualRow = isVirtual ? (virtualOrRow as VirtualItem) : undefined

        return (
          <TableBodyRow
            key={isVirtual ? virtualRow?.key : row.id}
            table={table}
            row={row}
            onRowClick={onRowClick}
            virtualRow={virtualRow}
            rowVirtualizer={rowVirtualizer}
            {...rest}
          />
        )
      })}
    </tbody>
  )
}
